import { useMemo } from "react";
import { Redirect, Route } from "react-router-dom";

import { useApp } from "../../contexts/app";
import Header from "../../componentes/header";

const PrivateRoute = (props: any) => {
  const { autenticado } = useApp();

  const rota = useMemo(() => {
    const dadosLocais = localStorage.getItem("@batalha-dev/autenticado");
    const tokenLocal = dadosLocais && JSON.parse(dadosLocais);

    if (autenticado.token || tokenLocal.token) {
      return (
        <>
          <Header />
          <Route {...props} />
        </>
      );
    } else {
      return <Redirect to="/login" />;
    }
  }, [props, autenticado]);

  return rota;
};

export default PrivateRoute;
